import React, { useState, useEffect, useRef } from "react";
import styles from "./MessageSettings.module.scss";
import { menuItems } from "./consts";
import { useTheme } from "../../../../contexts/ThemeContext";

const MessageSettings = ({ setSettings }) => {
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);
  const { theme } = useTheme();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setSettings(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.menu} ref={menuRef}>
      {menuItems.map((item, index) => (
        <div
          key={index}
          className={styles.menuItem}
          onClick={() => setOpenMenu(openMenu === index ? null : index)}
        >
          <button className={styles.button}>
            {React.cloneElement(item.icon, {
              color: theme === "dark" ? "white" : "#000000",
            })}
            {item.label}
          </button>

          {item.subItems && openMenu === index && (
            <div className={styles.subMenu}>
              {item.subItems.map((subItem, subIndex) => (
                <button
                  key={subIndex}
                  className={styles.subButton}
                  onClick={() => {
                    setOpenMenu(null);
                    setSettings(false);
                  }}
                >
                  {React.cloneElement(subItem.icon, {
                    color: theme === "dark" ? "white" : "#000000",
                  })}
                  {subItem.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
      <button className={styles.clearFilters}>Сбросить</button>
    </div>
  );
};

export default MessageSettings;
